import AllActionTypes from '../Utility/AllActionTypes';
const defaultState = {
    "loaderState": false, "leftbar": false,
    selected_branch: {},
    "activeLink": {
        'accName': "",
        'activeClass': "",
        'lockFlag': true,
        'planningEditableDay': 0
    },
    roleWisePermission: {},
    themeSettings: null,
    userSearchData: {
        destination: "",
        type: "",
        location: "",
        start_date: new Date(),
        end_date: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
        adult: 1,
        children: 0,
        selectedRoom: {},
        children_age: [],
        filterData: {}
    },
    userSearchDataError: {
        destination: "",
        type: "",
        location: "",
        start_date: null,
        end_date: null,
        adult: 1,
        children: 0,
        children_age: [],
        selectedRoom: {},
        filterData: {}
    },
    priceDistributionRequestData: [],
    priceDistributionResponseData: {},
    trendingDestination: { 'location': '', 'type': '' },
    groupTourPackageSearchData: {
        from_location: "",
        to_location: "",
        search: ""
    },
    bookingModeSelectedData: [
        { label: 'Night Booking', value: 'night', isSelected: true },
        { label: 'Slot Booking', value: 'slot', isSelected: false },
    ],
}
export default (state = defaultState, action) => {
    switch (action.type) {
        case AllActionTypes.LOADER_STATE_TRUE:
            return { ...state, "loaderState": action.payload };
        case AllActionTypes.LOADER_STATE_FALSE:
            return { ...state, "loaderState": action.payload };
        case AllActionTypes.ROLE_PERMISSION:
            return { ...state, "roleWisePermission": action.payload };
        case AllActionTypes.SELECT_BRANCH_DATA:
            return { ...state, "selected_branch": action.payload };
        case AllActionTypes.LOCK_FLAG:
            return { ...state, "lockFlag": action.payload };
        case AllActionTypes.PLANNING_EDITABLE_BEFORE_CURRENT_DAY:
            return { ...state, "planningEditableDay": action.payload };
        case AllActionTypes.USER_SEARCH_DATA:
            return { ...state, "userSearchData": action.payload };
        case AllActionTypes.USER_SEARCH_DATA_ERROR:
            return { ...state, "userSearchDataError": action.payload };
        case AllActionTypes.PRICE_DISTRIBUTION_REQUEST_DATA:
            return { ...state, "priceDistributionRequestData": action.payload };
        case AllActionTypes.PRICE_DISTRIBUTION_RESPONSE_DATA:
            return { ...state, "priceDistributionResponseData": action.payload };
        case AllActionTypes.TRENDING_DESTINATION:
            return { ...state, "trendingDestination": action.payload };
        case AllActionTypes.TOUR_SEARCH_DATA:
            return { ...state, "tourSearchData": action.payload };
        case AllActionTypes.HOTEL_GROUP_PACKAGE_SELECTED_DATA:
            return { ...state, "hotelGroupPackageSelectedData": action.payload };
        case AllActionTypes.GROUP_TOUR_PACKAGE_SEARCH_DATA:
            return { ...state, "groupTourPackageSearchData": action.payload };
        case AllActionTypes.GLOBAL_SEO_DATA:
            return { ...state, "globalSeoData": action.payload };
        case AllActionTypes.THEME_SETTINGS:
            return { ...state, "themeSettings": action.payload };

        case AllActionTypes.CLEAR_DATA:
            return { ...action.payload, themeSettings: state.themeSettings, bookingModeSelectedData: state.bookingModeSelectedData};
        
        case AllActionTypes.BOOKING_MODE_SELECTED_DATA:
            return { ...state, "bookingModeSelectedData": action.payload };
            
        default:
            return state;
    }
};
